"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CBOR = require("@wireapp/cbor");
var ClassUtil_1 = require("../util/ClassUtil");
var Message_1 = require("./Message");
var Envelope = (function () {
    function Envelope() {
        this._message_enc = new Uint8Array([]);
        this.mac = new Uint8Array([]);
        this.message = new Message_1.default();
        this.version = -1;
    }
    Envelope.new = function (mac_key, message) {
        var serialized_message = new Uint8Array(message.serialise());
        var env = ClassUtil_1.default.new_instance(Envelope);
        env.version = 1;
        env.mac = mac_key.sign(serialized_message);
        env.message = message;
        env._message_enc = serialized_message;
        Object.freeze(env);
        return env;
    };
    Envelope.prototype.verify = function (mac_key) {
        return mac_key.verify(this.mac, this._message_enc);
    };
    Envelope.prototype.serialise = function () {
        var encoder = new CBOR.Encoder();
        this.encode(encoder);
        return encoder.get_buffer();
    };
    Envelope.deserialise = function (buf) {
        var decoder = new CBOR.Decoder(buf);
        return Envelope.decode(decoder);
    };
    Envelope.prototype.encode = function (encoder) {
        encoder.object(3);
        encoder.u8(0);
        encoder.u8(this.version);
        encoder.u8(1);
        encoder.object(1);
        encoder.u8(0);
        encoder.bytes(this.mac);
        encoder.u8(2);
        return encoder.bytes(this._message_enc);
    };
    Envelope.decode = function (decoder) {
        var env = ClassUtil_1.default.new_instance(Envelope);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0: {
                    env.version = decoder.u8();
                    break;
                }
                case 1: {
                    var nprops_mac = decoder.object();
                    for (var subindex = 0; subindex <= nprops_mac - 1; subindex++) {
                        switch (decoder.u8()) {
                            case 0:
                                env.mac = new Uint8Array(decoder.bytes());
                                break;
                            default:
                                decoder.skip();
                        }
                    }
                    break;
                }
                case 2: {
                    env._message_enc = new Uint8Array(decoder.bytes());
                    break;
                }
                default: {
                    decoder.skip();
                }
            }
        }
        env.message = Message_1.default.deserialise(env._message_enc.buffer);
        Object.freeze(env);
        return env;
    };
    return Envelope;
}());
exports.default = Envelope;
//# sourceMappingURL=Envelope.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/message/Envelope.js
// module id = 65
// module chunks = 0 1